export const REDUCER_NAME="instagramCampaignSlice";

export interface iInstagramCampaignDTO {
    id?: string;
    name?: string;
    Objective?: string;
    status?: string;
    created_time?: string; 
    special_ad_categories: string[];
    is_adset_budget_sharing_enabled: boolean;  
}

export interface iInstagramCampaignState {
    instagramCampaignList: iInstagramCampaignDTO[] | null;
    isLoading: boolean;
    errorMessage: string | null;
}